import { gql } from '@apollo/client';

export const fetchLinkedApps = gql`
  query fetchLinkedApps($id: String, $searchLinkedEntitlementParams: SearchLinkedEntitlementParams) {
    entitlementDetails(id: $id) {
      linkedEntitlements(searchLinkedEntitlementParams: $searchLinkedEntitlementParams) {
        entitlementId
      }
    }
  }
`;
